import { ProgramMonitoringPeriod } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export default async function getProgramMonitoringPeriods({
  query,
  signal,
}: {
  query?: Partial<ProgramMonitoringPeriod>
  signal?: AbortSignal
}): Promise<ProgramMonitoringPeriod[]> {
  const response = await apiClient.get(endpoints.programMonitoringPeriods, {
    params: query,
    signal,
  })
  return unwrapCollection<ProgramMonitoringPeriod>(response)
}
